import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { BASE_URL, OPERKIND_CAR } from '../../../constant-value';
import ServiceIcon from '../card-two-side/service-icon';
import { SiSpeedtest } from 'react-icons/si';
import { FaRegCalendarAlt } from 'react-icons/fa';
import BtnOperkinds from './btn-operkinds';
import api from '../../../services/axiosConfig';
import { motion } from "framer-motion";
import { IoChevronBackOutline } from "react-icons/io5";
import SpinnerWrapper from '../../pages/spinnerWrapper';
import { PuffLoader } from 'react-spinners';


const ServiceStepTwo = () => {
    const { carId, carTitle } = useParams();
    const [operKinds, setOperKinds] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, sethasError] = useState(false);

    const navigate = useNavigate();

    // const nextHandler = () => {
    //   navigate('/add-service-step-3')
    //   // console.log(operKinds);
    // };

    const beforeHandler = () => {
      navigate(-1);
    };

    // const closeHandler = () => {
    //   // navigate('/courses')
    //   navigate(-1);
    // };
  
    
  const getAllOperkind = () => {
    setIsLoading(true);

    api.get(`/${OPERKIND_CAR}/${carId}`)
        .then(result => { 
          setOperKinds(result.data);
          sethasError(false);
        }) 
        .catch(error => { 
          sethasError(true);
        })
        .finally(() => {
          setIsLoading(false);
        });

    // axios.get(`${BASE_URL}/${OPERKIND_CAR}/${carId}`) 
    // .then(result => { 
    //     setOperKinds(result.data);
    //     sethasError(false);
    // }) 
    // .catch(error => { 
    //   sethasError(true);
    // })
    // .finally(() => {
    //   setIsLoading(false);
    // });

  };

  useEffect(getAllOperkind, []);

      const numberChangeHandler = (evt) => {
        // setCar({
        //   ...car,
        //   [evt.target.id]: parseFloat(evt.target.value),
        // })
      }

  return (
    <div className="container py-3">
      {isLoading ? (
        <SpinnerWrapper>
          <PuffLoader color="green" loading={true} size={60} />
        </SpinnerWrapper>
      ) : (
      <div className="card shadow-lg border-0 rounded-3 overflow-hidden">
        
        {/* Header */}
        <div className="card-header bg-primary text-white d-flex align-items-center justify-content-between">
          <motion.button
            type="button"
            className="btn btn-light btn-sm rounded-circle d-flex align-items-center justify-content-center"
            style={{ width: "36px", height: "36px" }}
            onClick={beforeHandler}
            aria-label="بازگشت"
            whileHover={{ scale: 1.15, rotate: -10 }}
            whileTap={{ scale: 0.9 }}
            transition={{ type: "spring", stiffness: 300, damping: 10 }}
          >
            <IoChevronBackOutline size={20} />
          </motion.button>
  
          <h5 className="mb-0 fw-bold text-center flex-grow-1">{carTitle}</h5>
  
          <div style={{ width: "36px" }}></div>
        </div>
  
        {/* Body */}
        <div className="card-body p-3">
          <div className="row g-3">
            {operKinds.map((res, index) => (
              <motion.div
                key={res.id}
                className="col-12 col-md-6 col-lg-4"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
              >
                <BtnOperkinds 
                  operkind={res} 
                  carId={carId} 
                  carTitle={carTitle}
                />
              </motion.div>
            ))}
          </div>
            {/* دکمه بازگشت */}
            <div className="mt-4 d-flex justify-content-end">
              <button className="btn btn-outline-primary px-4" 
                type="button" 
                onClick={beforeHandler}
              >
                قبلی
              </button>
            </div>
        </div>
      </div>
    )}
    </div>
  );  
}

export default ServiceStepTwo